import * as positionAction from './position-action'

export {
  positionAction,
}



// WEBPACK FOOTER //
// ./src/actions/position/index.js